import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, useEffect, useState } from 'react';
import './App.css';
import { RouterProvider } from "react-router-dom";
import { appRouter } from "./AppRouter";
import SkeletonPage from "./pages/skeleton";
import { YMInitializer } from 'react-yandex-metrika';
import arrowUp from './arrow_up.png';
import { isMobile } from 'react-device-detect';
import { authService, legalDocumentsService } from "./global";
function App() {
    const [isLoading, setIsLoading] = useState(true);
    const windowSize = window.screen.width;
    const legalDocumentService = legalDocumentsService;
    useEffect(() => {
        window.addEventListener("scroll", (e) => onEventScroll(e));
        return () => {
            window.removeEventListener("scroll", (e) => onEventScroll(e));
        };
    });
    useEffect(() => {
        authService.initialize().then(async (result) => {
            await legalDocumentService.fetchLegalDocuments();
            setIsLoading(false);
        }).catch(err => {
            console.log(err);
            setIsLoading(false);
        });
    }, []);
    function onEventScroll(event) {
        var screenHeight = window.screen.height;
        if (window.scrollY > screenHeight * 1.5) {
            updateFloationButtonState('1');
        }
        else {
            updateFloationButtonState('0');
        }
    }
    function onClickToFloatinButton() {
        window.scrollTo(0, 0);
    }
    function updateFloationButtonState(opacity) {
        var button = document.getElementById("floating-button");
        if (button == null) {
            return;
        }
        button.style.opacity = opacity;
    }
    if (isLoading) {
        return _jsx(SkeletonPage, { isMobile: isMobile });
    }
    return (_jsxs(Suspense, { fallback: _jsx(SkeletonPage, { isMobile: isMobile }), children: [_jsx(RouterProvider, { router: appRouter(isMobile) }), _jsxs("button", { className: 'core-floating-button', id: "floating-button", onClick: onClickToFloatinButton, children: ["\u041D\u0430\u0432\u0435\u0440\u0445", _jsx("img", { className: 'arrowUp', src: arrowUp, alt: 'ginfotech' })] }), _jsx(YMInitializer, { accounts: [95021386], options: { webvisor: true } })] }));
}
export default App;
